import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import c from 'classnames';
import { CommentContext } from '../../CommentContext';
import { CommentableTypes } from '../../redux/types';
import s from './ContentBox.scss';
/**
 * The padding and background for the main content of a comment.
 *
 * We tend to put the byline and text content in one of these.
 */ const ContentBox = (_param)=>{
    var { children, className } = _param, rest = _object_without_properties(_param, [
        "children",
        "className"
    ]);
    const { comment } = useContext(CommentContext);
    const { isFeatured } = comment;
    return /*#__PURE__*/ React.createElement("div", _object_spread({
        className: c(s['root'], 'ds-surface-secondary', isFeatured && s['featured'], className, comment.typeId === CommentableTypes.COMMENT_DEVIATION && s['deviation'])
    }, rest), children);
};
ContentBox.displayName = 'ContentBox';
export default ContentBox;

//# sourceMappingURL=ContentBox.js.map